import script from "./PointageView.vue?vue&type=script&setup=true&lang=js"
export * from "./PointageView.vue?vue&type=script&setup=true&lang=js"

import "./PointageView.vue?vue&type=style&index=0&id=585641a2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-585641a2"]])

export default __exports__